// Enable this if needed
/* eslint-disable */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { store, history } from './utils/store';
import Root from './containers/Root';
import styles from './style/main.scss';

/* eslint-enable */

// eslint-disable-next-line no-unused-vars
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root store={store} history={history} />);

if (module.hot) {
  module.hot.accept();
}
